@if (variant() === 'button' || !isLoading()) {
  <button
    motifButton
    (click)="onClick()"
    [color]="color()"
    size="small"
    id="request-create-download-template-button"
    [disabled]="isDisabled()">
    @if (isLoading()) {
      <span class="loader"></span>
    } @else if (iconFunction() !== undefined) {
      <motif-icon [iconFunction]="iconFunction()" />
    }
    {{ label() }}
  </button>
} @else if (isLoading() && variant() === 'text') {
  <div class="loader-text-container">
    <span class="loader"></span>
    <span class="loading-text">
      {{ loadingText() }}
    </span>
  </div>
}
